import React, { useState, useRef } from 'react';
import { IconHelp } from "@tabler/icons-react";
import { Grid, Checkbox, Text, Modal, Group, Button } from '@mantine/core';
import { SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";
import ReactDOM from 'react-dom';

export function SelectMetrics({
    generalColumns,
    setGeneralColumns,
    goalColumns,
    setGoalColumns,
    trafficSourceColumns,
    setTrafficSourceColumns,
    organicTrafficMetricsColumns,
    sourceMetricsColumns,
    setSourceMetricsColumns,
    conversionGoalOptions,
    setOrganicTrafficColumns,
    setSourceColumns,
    setCustomTagColumns,
    setTrackingTagColumns,
    setCampaignColumns,
    testVariationColumns,
    setTestVariationColumns,
    trafficFunnelMetricsColumns,
    setTrafficFunnelMetricsColumns,
    organicTrafficDataTable
  }:any) {

  const [selectMetricsModalOpen, setSelectMetricsModalOpen] = useState(false);
  const selectMatricRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleSelectMetricsOpenModal = (value:any) => {
    setSelectMetricsModalOpen(true);
  };

  const handleSelectMetricsCloseModal = () => {
    setSelectMetricsModalOpen(false);
  };

  const handleGeneralMetricsColumns = (key, value) => {
    const updatedGeneralColumns = generalColumns.map((data) => {
      if (data.key === key) {
        return { ...data, show: !data.show };
      }
      return data;
    });
    setGeneralColumns(updatedGeneralColumns);
  };

  const handleSelectAllGeneralMetricsColumns = () => {
    const updatedAllGeneralColumns = !generalColumns.every(data => data.show);
    generalColumns.forEach(data => {
      data.show = updatedAllGeneralColumns;
    });
    setGeneralColumns([...generalColumns]); 
  };

  const handleSelectAllGoalColumnsMetricsColumns = () => {
    const updatedAllGoalColumns = goalColumns.every(data => data.show);
    const newShowState = !updatedAllGoalColumns;

    const updatedGoalColumns = goalColumns.map(data => ({
      ...data,
      show: newShowState
    }));
    setGoalColumns(updatedGoalColumns);

    const updatedTestVariationColumns = testVariationColumns.map(data => {
      if (data.key === 'variation' && goalColumns.some(col => col.key === 'goalName')) {
        return { ...data, show: newShowState };
      }
      if (goalColumns.find(col => col.key === data.key)) {
        return { ...data, show: newShowState };
      }
      return data;
    });
    setTestVariationColumns(updatedTestVariationColumns); 
  };

  const handleSelectAllTrafficSourceMetricsColumns = () => {
    const updatedAllTrafficSourceColumns = !trafficSourceColumns
    .filter(col => col.key !== 'campaign_name')
    .every(col => col.show);
    const updatedColumns = trafficSourceColumns.map(col => {
      if (col.key === 'campaign_name') {
        return { ...col, show: true };
      }
      return { ...col, show: updatedAllTrafficSourceColumns };
    });
    setTrafficSourceColumns(updatedColumns);

    /*SET SOURCE COLUMNS*/
    const updatedSourceMetricsColumns = Object.entries(sourceMetricsColumns).map(
      ([index, data]) => {
        const column = data as { key: string; value: string; show: boolean };
        if (column.key === 'c_r_source_name') {
          return { ...column, show: true };
        }
        return { ...column, show: updatedAllTrafficSourceColumns };
      }
    );
    setSourceMetricsColumns(updatedSourceMetricsColumns);
  };

  const handleSelectAllTrafficFunnelMetricsColumns = () => {
    const updatedAllTrafficFunnelColumns = !trafficFunnelMetricsColumns.every(data => data.show);
    trafficFunnelMetricsColumns.forEach(data => {
      data.show = updatedAllTrafficFunnelColumns;
    });
    setTrafficFunnelMetricsColumns([...trafficFunnelMetricsColumns]); 
  };
  
  const handleTrafficFunnelColumnsMetrics = (key, value) => {
    const updatedTrafficFunnelMetricsColumns = trafficFunnelMetricsColumns.map((data) => {
       if (data.key === key) {
        return { ...data, show: !data.show };
      }
      return data;
    });
    setTrafficFunnelMetricsColumns(updatedTrafficFunnelMetricsColumns);
  };
  const handleGoalColumnsMetrics = (key, value) => {
    const updatedGoalColumns = goalColumns.map((data) => {
      if (data.key === key) {
        return { ...data, show: !data.show };
      }
      return data;
    });
    setGoalColumns(updatedGoalColumns);
    const updatedTestvariationColumns = testVariationColumns.map((data) => {
      if(data.key === 'variation' && key === 'goalName'){
        return { ...data, show: !data.show };
      }
      if (data.key === key) {
        return { ...data, show: !data.show };
      }
      return data;
    });
    setTestVariationColumns(updatedTestvariationColumns);
  };

  const handleTrafficSourceColumnsMetrics = (key, value) => {
    /*SET TRAFFIC SOURCE COLUMNS*/
    const updatedTrafficSourceColumns = trafficSourceColumns.map((data) => {
      if (data.key === key) {
        return { ...data, show: !data.show };
      }
      return data;
    });
    setTrafficSourceColumns(updatedTrafficSourceColumns);

    /*SET SOURCE COLUMNS*/
    const updatedSourceMetricsColumns = Object.entries(sourceMetricsColumns).map(
      ([index, data]) => {
        const column = data as { key: string; value: string; show: boolean };
        if (column.key.includes(key)) {
          return { ...column, show: !column.show };
        }
        return column;
      }
    );
    setSourceMetricsColumns(updatedSourceMetricsColumns);
  };

  const handleSaveMetrics = (event) => {
    event.preventDefault();
    const visibleTrafficSourceColumns = trafficSourceColumns.filter(column => column.show);
    const visibleTrafficFunnelMetricsColumns = trafficFunnelMetricsColumns.filter(column => column.show);
    if(conversionGoalOptions.length > 0){
      conversionGoalOptions.forEach((currentCampaign, currentCampaignIndex) => {
        const combinedColumns = [...sourceMetricsColumns, ...trafficFunnelMetricsColumns];

        setSourceColumns((prev) => {
          const updatedSourceColumns = {
            ...prev,
            [currentCampaign.campaign_id]: combinedColumns,
          };
          return updatedSourceColumns;
        });

        /*SET TRACKING TAG AND CUSTOM TAG COLUMN*/
        conversionGoalOptions.forEach((currentCampaign) => {
          const campaignId = currentCampaign.campaign_id;

          setTrackingTagColumns((prev) => {
            const existingColumns = prev[campaignId] || [];
            const updatedTrackingTagColumns = existingColumns.map((existingColumn) => {
              const matchingSourceMetric = Object.values(combinedColumns).find(
                (data) => existingColumn.key.includes(data.key)
              );

              return {
                ...existingColumn,
                ...(matchingSourceMetric ? { show: matchingSourceMetric.show } : {}),
              };
            });

            const setTracking =  {
              ...prev,
              [campaignId]: updatedTrackingTagColumns,
            };
            return setTracking;
          });

            if (currentCampaign.customTagData) {
              Object.entries(currentCampaign.customTagData).forEach(([customTagName, columns]) => {
                setCustomTagColumns((prev) => {
                  const updatedPrev = prev || {}; 
                  const campaignColumns = updatedPrev[campaignId] || {};
                  const existingColumns = campaignColumns[customTagName];
                  const updatedCampaignColumns = existingColumns && existingColumns.map((column) => {
                    const matchingSourceMetric = Object.values(combinedColumns).find(
                      (data) => column.key.includes(data.key)
                    );

                    return {
                      ...column,
                      ...(matchingSourceMetric ? { show: matchingSourceMetric.show } : {}),
                    };
                  });
                  
                    const updatedData = {
                      ...updatedPrev,
                      [campaignId]: {
                          ...campaignColumns,
                          [customTagName]: updatedCampaignColumns,
                      },
                  };
                  return updatedData;
                });
              });
            }
        });

        const trafficSourceNames = ['facebook', 'google', 'microsoft', 'tiktok', 'applovin', 'outbrain', 'linkedin', 'chatgpt'];
        const trafficSourceAdsetNames = ['facebookAdset', 'googleAdset', 'microsoftAdset', 'tiktokAdset', 'applovinAdset','linkedinAdset'];
        const trafficSourceAdsNames = ['facebookAds', 'googleAds', 'microsoftAds', 'tiktokAds', 'linkedinAds'];
        setCampaignColumns((prev) => {
          const updatedCampaigns = {};

          trafficSourceNames.forEach((traffic) => {
            updatedCampaigns[traffic] = [];
            let trafficSourceFound = false;

            visibleTrafficSourceColumns.flatMap((col) => {
              if (col.key === 'device_name') { return; }
              if (col.key === 'traffic_source') {
                trafficSourceFound = true;
              }
              if((traffic === 'outbrain' || traffic === 'tiktok') && col.key === 'campaign_name'){
                updatedCampaigns[traffic].push(['campaignid', 'Campaign Id']);
              }else if(traffic === 'linkedin' && col.key === 'campaign_name'){
                updatedCampaigns[traffic].push(['campaign_name', 'Campaign Group Name']);
              }else{
                updatedCampaigns[traffic].push([col.key, col.value]);
              }
              if (traffic === 'google' && col.key === 'campaign_name') {
                updatedCampaigns[traffic].push(['placement', 'Placement']);
              }
            });

            if (!trafficSourceFound) {
              updatedCampaigns[traffic].unshift(['checkbox', false]);
            } else {
              const trafficSourceIndex = updatedCampaigns[traffic].findIndex(col => col[0] === 'traffic_source');
              updatedCampaigns[traffic].splice(trafficSourceIndex + 1, 0, ['checkbox', false]);
            }
              visibleTrafficFunnelMetricsColumns.forEach((data) => {
                updatedCampaigns[traffic] = (updatedCampaigns[traffic] || []).concat(
                  [[data.key, data.value]]
                );
              });
          });

          trafficSourceAdsetNames.forEach((traffic) => {
            updatedCampaigns[traffic] = [];
            let trafficSourceFound = false;
            visibleTrafficSourceColumns.flatMap((col) => {
              if (col.key === 'device_name') { return; }
              if (col.key === 'traffic_source') {
                trafficSourceFound = true;
              }
              if(col.key === 'campaign_name'){
                if(traffic === 'tiktokAdset'){
                  updatedCampaigns[traffic].push(['campaignid', 'Campaign Id']);
                  updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
                }
                if(traffic === 'linkedinAdset'){
                  updatedCampaigns[traffic].push(['campaign_name', 'Campaign Group Name']);
                  updatedCampaigns[traffic].push(['adset_name', 'Campaign Name']);
                }
                if(traffic !== 'applovinAdset' && traffic !== 'tiktokAdset' && traffic !== 'linkedinAdset'){
                  updatedCampaigns[traffic].push([col.key, col.value]);
                  updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
                }
                if(traffic === 'applovinAdset'){
                  updatedCampaigns[traffic].push([col.key, col.value]);
                  updatedCampaigns[traffic].push(['adset_name', 'Ad']);
                }
                if(traffic === 'googleAdset'){
                  updatedCampaigns[traffic].push(['placement', 'Placement']);
                }
              }
              else {
                updatedCampaigns[traffic].push([col.key, col.value]);
              }
            });
            if (trafficSourceFound) {
              const index = updatedCampaigns[traffic].findIndex((c) => c[0] === 'traffic_source');
              updatedCampaigns[traffic].splice(index + 1, 0, ['checkbox', false]);
            } else {
              updatedCampaigns[traffic].unshift(['checkbox', false]);
            }
              visibleTrafficFunnelMetricsColumns.forEach((data) => {
                  updatedCampaigns[traffic] = (updatedCampaigns[traffic] || []).concat(
                    [[data.key, data.value]]
                  );
              });
          });

          trafficSourceAdsNames.forEach((traffic) => {
            updatedCampaigns[traffic] = [];
            let trafficSourceFound = false;
            visibleTrafficSourceColumns.flatMap((col) => {
              if (col.key === 'device_name') { return; }
              if (col.key === 'traffic_source') {
                trafficSourceFound = true;
              }
              if (col.key === 'campaign_name' && traffic !== 'tiktokAds' && traffic !== 'linkedinAds') {
                updatedCampaigns[traffic].push([col.key, col.value]);
                updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
                updatedCampaigns[traffic].push(['ad_name', 'Ad']);
                if(traffic === 'googleAds'){
                  updatedCampaigns[traffic].push(['placement', 'Placement']);
                }
              }
              if(traffic === 'tiktokAds' && col.key === 'campaign_name'){
                updatedCampaigns[traffic].push(['campaignid', 'Campaign Id']);
                updatedCampaigns[traffic].push(['adset_name', 'Ad Set / Group Name']);
                updatedCampaigns[traffic].push(['ad_name', 'Ad']);
              }
              if(traffic === 'linkedinAds' && col.key === 'campaign_name'){
                updatedCampaigns[traffic].push(['campaign_name', 'Campaign Group Name']);
                updatedCampaigns[traffic].push(['adset_name', 'Campaign Name']);
                updatedCampaigns[traffic].push(['ad_name', 'Ad']);
              }
              else{
                updatedCampaigns[traffic].push([col.key, col.value]);
              }
            });

            if (trafficSourceFound) {
              const index = updatedCampaigns[traffic].findIndex((c) => c[0] === 'traffic_source');
              updatedCampaigns[traffic].splice(index + 1, 0, ['checkbox', false]);
            } else {
              updatedCampaigns[traffic].unshift(['checkbox', false]);
            }
              visibleTrafficFunnelMetricsColumns.forEach((data) => {
                  updatedCampaigns[traffic] = (updatedCampaigns[traffic] || []).concat(
                    [[data.key, data.value]]
                  );
              });
          });

          return {
            ...prev,
            ...updatedCampaigns,
          };
        });
      });
    }
    setSelectMetricsModalOpen(false);
    if(Object.keys(organicTrafficDataTable).length > 0){
      Object.entries(organicTrafficDataTable).map(([campaign_name, tableData]) => {
        const organicTh = (tableData as any).organic_traffic?.th || {};
        const transformedMetrics = Object.keys(organicTh).map(orgKey => {
          const slug = orgKey.split('_').slice(3).join('_');
          const matched = trafficFunnelMetricsColumns.find(t => t.key === orgKey);
          const slugShow = trafficFunnelMetricsColumns.some(t => {
            const tSlug = t.key.split('_').slice(3).join('_');
            return tSlug === slug && t.show === true;
          });
          let finalShow = false;

          if (matched) {
            finalShow = matched.show;
          } else {
            finalShow = slugShow;
          }
          if (String(organicTh[orgKey]).includes('(Combined)')) {
            finalShow = slugShow;
          }

          return {
            key: orgKey,
            value: organicTh[orgKey],
            show: finalShow
          };
        });

        setOrganicTrafficColumns(prev => ({
          ...prev,
          [campaign_name]: [
            ...organicTrafficMetricsColumns,
            ...transformedMetrics 
          ]
        }));
      });
    }
  };

  const handleHelpClick = (id:any) => {

    setShowHelpModal(true);
    setHelpTargetId(id);
    if (selectMatricRef.current) {
      const { top, left, width } = selectMatricRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  return (
    <>
    {showHelpModal &&
        ReactDOM.createPortal(
          <div style={{ zIndex: 9999 }}>
            <SelectTooltip
              isVisible={showHelpModal}
              setIsVisible={setShowHelpModal}
              id={helpTargetId}
              tooltipPosition={tooltipPosition}
            />
          </div>,
          document.body
        )}
      <Modal.Root opened={selectMetricsModalOpen} onClose={handleSelectMetricsCloseModal} size="75%" trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>SELECT METRICS <IconHelp size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} ref ={selectMatricRef} onClick={() => handleHelpClick(339)}/></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body style={{ overflow: 'hidden' }}>
            <Text>Select metrics to be displayed in the report table: </Text>
            <form onSubmit={handleSaveMetrics}>
              <Grid gutter={5} gutterXs="md" gutterMd="xl" gutterXl={50}>
                <Grid.Col span={3}>
                  <Text weight={500} mt={10} mb={5}>Revenue Summary</Text>
                  <Checkbox
                    mb={25}  
                    checked={generalColumns.every(data => data.show)}  
                    onChange={() => handleSelectAllGeneralMetricsColumns()} 
                    label="Select All"
                  />
                  {generalColumns.map((data, index) => (
                      <Checkbox
                        key={index}
                        mb={3}
                        checked={data.show}
                        onChange={() => handleGeneralMetricsColumns(data.key, data.value)}
                        label={data.value}
                      />
                  ))}
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text weight={500} mt={10} mb={5}>Funnel Metrics</Text>
                  <Checkbox
                    mb={25}  
                    checked={goalColumns.every(data => data.show)}  
                    onChange={() => handleSelectAllGoalColumnsMetricsColumns()} 
                    label="Select All"
                  />
                  {goalColumns.map((data, index) => (
                      <Checkbox
                        key={index}
                        mb={3}
                        checked={data.show}
                        onChange={() => handleGoalColumnsMetrics(data.key, data.value)}
                        label={data.value}
                      />
                  ))}
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text weight={500} mt={10} mb={5}>Traffic Metrics</Text>
                  <Checkbox
                    mb={25}
                    checked={trafficSourceColumns.every(data => data.show)}
                    onChange={() => handleSelectAllTrafficSourceMetricsColumns()}
                    label="Select All"
                  />
                  <Text size={14} fw={500} mt={5} mb={5}>Traffic & Engagement Metrics</Text>
                    {trafficSourceColumns
                      .filter(data => ['traffic_source', 'uniques', 'visits', 'impressions', 'ctr', 'cpc', 'cpm'].includes(data.key))
                      .map((data, index) => (
                        <Checkbox
                          key={index}
                          mb={3}
                          checked={data.show}
                          onChange={() => handleTrafficSourceColumnsMetrics(data.key, data.value)}
                          label={data.value}
                        />
                      ))
                    }

                    <Text size={14} fw={500} mt={10} mb={5}>Spend & Revenue Metrics</Text>
                    {trafficSourceColumns
                      .filter(data => ['ad_spend', 'network_reported_revenue','network_conversions'].includes(data.key))
                      .map((data, index) => (
                        <Checkbox
                          key={index}
                          mb={3}
                          checked={data.show}
                          onChange={() => handleTrafficSourceColumnsMetrics(data.key, data.value)}
                          label={data.value}
                        />
                      ))
                    }
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text weight={500} mt={10} mb={5}>Traffic Funnel Metrics</Text>
                  <Checkbox
                    mb={25}  
                    checked={trafficFunnelMetricsColumns.every(data => data.show)}  
                    onChange={() => handleSelectAllTrafficFunnelMetricsColumns()} 
                    label="Select All"
                  />
                   {trafficFunnelMetricsColumns.map((data, index) => (
                    <Checkbox
                        key={index}
                        mb={3}
                        checked={data.show}
                        onChange={() => handleTrafficFunnelColumnsMetrics(data.key, data.value)}
                        label={data.value}
                      />
                  ))}
                </Grid.Col>
              </Grid>
              <Group position="right">
                <Button type="submit" size="sm" w={80} mt={10}>
                  Save
                </Button>
              </Group>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root> 

      <Group position="left">
        <Button color="teal" onClick={() => handleSelectMetricsOpenModal(1)}>
          Select Metrics
        </Button>
      </Group>
    </>
  );
}